export const MODULE_NAME = 'thirdpartyApis';
export const BASE_API = 'apis';

//APIs
export const APIS = 'apis';
export const SET_APIS = 'setApis';
export const SET_INTEGRATIONS_APIS = 'setIntegrationsAPIs';

import {
	ERROR as error,
	SET_ERROR as setError
} from '@/sections/error-mutation-types';

export const ERROR = error;
export const SET_ERROR = setError;

import {
	LOADING as loading,
	SET_LOADING as setLoading
} from '@/sections/loading-mutation-types';

export const LOADING = loading;
export const SET_LOADING = setLoading;

import { TOAST_MESSAGES_PUSH as pushMessage } from '@/sections/loading-mutation-types';

export const TOAST_MESSAGES_PUSH = pushMessage;
